export interface ExportType {
    id: number;
    type: string;
}

export interface DuplicateResolutionType {
    id: string;
    type: string;
}

export interface HubSpotExportType {
    id: string;
    type: string;
}

export interface FieldsAndSettings<T = any, M = MappingField> {
    settings: SettingsResponse<T, M>;
    fields: any;
    exportSettings?: any;
    scopes?: any;
}

export interface SettingsResponse<T = any, M = MappingField> {
    general?: T;
    leadMapping?: M[];
    contactMapping?: M[];
    companyMapping?: M[];
    accountMapping?: M[];
    LeadMapping?: M[];
    ContactMapping?: M[];
    CompanyMapping?: M[];
    AccountMapping?: M[];
    error?: any;
}
export interface MappingField {
    allowAutoUpdate: boolean;
    allowOverwrite: boolean;
    crmTechnology?: string;
    customizable?: boolean;
    dynamicsField?: string;
    fieldGroup: string;
    groupId: number;
    hubspotField?: string;
    isCustomizable?: boolean;
    orderId: number;
    order?: string;
    outreachField?: string;
    salesforceField?: string;
    salesintelField: string;
    salesintelTechnology?: string;
    salesloftField?: string;
    type: string;
    useFullName?: boolean;
    zohoField?: string;
}
export default class SettingsCRM {
    static ExportTypes: Array<ExportType> = [
        { id: 1, type: 'Prompt' },
        { id: 2, type: 'Contact' },
        { id: 3, type: 'Lead' }
    ];
    static ExportTypesRoD: Array<ExportType> = [
        { id: 2, type: 'Contact' },
        { id: 3, type: 'Lead' }
    ];
    static HubSpotExportTypesRoD: Array<HubSpotExportType> = [
        { id: 'subscriber', type: 'Subscriber' },
        { id: 'lead', type: 'Lead' }
    ];
    static ExportTypesHubSpot: Array<HubSpotExportType> = [
        { id: 'prompt', type: 'Prompt' },
        { id: 'subscriber', type: 'Subscriber' },
        { id: 'lead', type: 'Lead' }
    ];
    static DuplicateResolutionTypes: Array<DuplicateResolutionType> = [
        { id: 'prompt', type: 'Prompt' },
        { id: 'skip', type: 'Always Skip' },
        { id: 'update', type: 'Always Update' },
        { id: 'append', type: 'Always Append Only (only blanks)' }
    ];
    static DuplicateResolutionTypesRoD: Array<DuplicateResolutionType> = [
        { id: 'skip', type: 'Skip' },
        { id: 'update', type: 'Update' },
        { id: 'append', type: 'Append' }
    ];
}

export const getDefaultTypeFromSettings = function (allowExportAsContact, allowExportAsLead) {
    if (allowExportAsContact && allowExportAsLead) {
        return 1;
    } else if (allowExportAsContact && !allowExportAsLead) {
        return 2;
    } else if (!allowExportAsContact && allowExportAsLead) {
        return 3;
    }
};

export const SalesintelFieldMap = {
    firstName: 'First Name',
    lastName: 'Last Name',
    title: 'Title',
    company: 'Company',
    name: 'Name',
    website: 'Website',
    fax: 'Fax',
    work_hq: 'HQ Phone',
    street: 'Street',
    city: 'City',
    state: 'State',
    postalCode: 'Postal Code',
    country: 'Country',
    stateAbbreviation: 'State Abbreviation',
    countryAbbreviation: 'Country Abbreviation',
    annualRevenue: 'Annual Revenue',
    linkedIn: 'LinkedIn',
    numberOfEmployees: 'Number Of Employees',
    sector: 'Sector',
    industry: 'Industry',
    naics: 'NAICS',
    hqPhone: 'HQ Phone',
    account: 'Account',
    email: 'Email',
    work_mobile: 'Work Mobile',
    work_phone: 'Work Phone',
    jobDepartment: 'Job Department',
    mobilePhone: 'Mobile Phone',
    phone: 'Phone',
    jobLevel: 'Job Level',
    source: 'Source',
    secondarySource: 'Secondary Source',
    personalEmail: 'Personal Email',
    leadSource: 'Lead Source',
    mobile: 'Mobile',
    locationType: 'Location Type',

    // primaryName: 'Primary Name',
    primary_name: 'Primary Name',
    // primaryDomain: 'Primary Domain',
    primary_domain: 'Primary Domain',
    employee_count: 'Employee Count',
    sic_codes: 'SIC',
    postal_code: 'Postal Code',
    phones_hq: 'HQ Phone',
    phones_work: 'Work Phone',
    first_name: 'First Name',
    last_name: 'Last Name',
    display_name: 'Display Name',
    job_department: 'Job Department',
    job_title: 'Job Title',
    // jobTitle: 'Job Title',

    work_branch: 'Branch Phone',
    work: 'Work Phone',
    mobile1: 'Mobile 1',
    mobile2: 'Mobile 2',
    company_id : 'Company Id',
    accuracyTier: 'Accuracy Tier',
    financeDepartmentSize: 'Finance Department Size',
    hrDepartmentSize: 'HR Department Size',
    itDepartmentSize: 'IT Department Size',
    legalDepartmentSize: 'Legal Department Size',
    marketingDepartmentSize: 'Marketing Department Size',
    operationsDepartmentSize: 'Operations Department Size',
    procurementDepartmentSize: 'Procurement Department Size',
    rndDepartmentSize: 'R&D Department Size',
    salesDepartmentSize: 'Sales Department Size',
    primarySector: 'Primary Sector',
    primaryIndustry: 'Primary Industry',
    primaryNaics: 'Primary NAICS',

    hqStreet: 'HQ Street',
    hqCity: 'HQ City',
    hqState: 'HQ State',
    hqStateAbbreviation: 'HQ State Abbreviation',
    hqPostalCode: 'HQ Postal Code',
    hqCountry: 'HQ Country',
    hqCountryAbbreviation: 'HQ Country Abbreviation',

    matchId: 'Match ID',
    companyId: 'Company ID',

    yearFounded: 'Year Founded',

    lastFundingRound: 'Last Funding Round',
    lastFundingDate: 'Last Funding Date',
    lastFundingAmount: 'Last Funding Amount',
    totalFundingAmount: 'Total Funding Amount'
};

export interface IntentMappingField {
    intentTopicId: number;
    crmDateField: string;
    crmIntentScoreField: string;
    intentMappingType: string;
}
